import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

export interface DocumentMobileIdentificationResponse {
  status: 'FAILED' | 'EXCEEDED' | 'SUCCEEDED';
  failureCount: number;
  lastFailedAt: string;
}

/**
 * POST 인증
 */
export function postDocumentsParticipantsVerificationMobileIdentification({
  documentId,
  participantId,
  impUid,
  authenticationKey,
  workspaceId,
}: {
  documentId: string;
  participantId: string;
  impUid: string;
  authenticationKey: string;
  workspaceId: string;
}): Promise<DocumentMobileIdentificationResponse> {
  return requestApi<DocumentMobileIdentificationResponse>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/verification/mobile-identification`
    ),
    method: 'POST',
    credentials: true,
    data: {
      impUid,
      verificationKey: authenticationKey,
    },
  }).then((response) => response.data);
}
